import React from 'react'
import VipLayout from '../../components/vip/VipLayout'

const VipFaqPage: React.FC = () => {
  return (
    <VipLayout>
      <section className="hero">
        <div className="container">
          <span className="kicker">FAQ</span>
          <h1>常见问题</h1>
          <p>帮助客户快速理解各类资质、备案与许可证之间的区别、边界与适用范围。</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="grid cols-2">
            <div className="card faq-card">
              <h3>ICP备案和 ICP 经营许可证有什么区别？</h3>
              <p className="lead" style={{fontSize: '15px'}}>ICP备案通常针对非经营性互联网信息服务，ICP 经营许可证则面向经营性互联网信息服务。</p>
            </div>
            <div className="card faq-card">
              <h3>EDI 许可证适用于哪些平台？</h3>
              <p className="lead" style={{fontSize: '15px'}}>一般需要结合交易撮合、在线数据处理及平台业务模式进一步判断。</p>
            </div>
            <div className="card faq-card">
              <h3>AI 算法备案和 AI 大模型备案有什么区别？</h3>
              <p className="lead" style={{fontSize: '15px'}}>算法备案与生成式 AI 大模型登记 / 备案并不是同一事项，应结合服务能力与模型形态判断。</p>
            </div>
            <div className="card faq-card">
              <h3>调用第三方大模型 API，还需要做登记或备案吗？</h3>
              <p className="lead" style={{fontSize: '15px'}}>不一定"调用别人模型就零义务"，仍需结合功能与服务对象判断是否进入登记范围。</p>
            </div>
            <div className="card faq-card">
              <h3>网络文化经营许可证什么时候需要？</h3>
              <p className="lead" style={{fontSize: '15px'}}>通常先判断业务是否属于网络表演、网络演出剧（节）目、网络音乐、网络动漫等经营性互联网文化活动。</p>
            </div>
            <div className="card faq-card">
              <h3>广播电视节目制作经营许可证适用于哪些企业？</h3>
              <p className="lead" style={{fontSize: '15px'}}>适用于从事广播电视节目制作经营活动的机构，不等同于普通互联网平台通用资质。</p>
            </div>
            <div className="card faq-card">
              <h3>安全评估报告和算法安全自评估报告是一回事吗？</h3>
              <p className="lead" style={{fontSize: '15px'}}>不是。算法备案常见的是算法安全自评估报告，生成式 AI 服务备案或高风险深度合成场景更可能涉及安全评估报告。</p>
            </div>
            <div className="card faq-card">
              <h3>咨询公司能替客户持有资质或备案吗？</h3>
              <p className="lead" style={{fontSize: '15px'}}>不能。许可证或备案的主体通常必须是客户企业本身，我们提供的是咨询、材料与流程辅导服务。</p>
            </div>
          </div>
        </div>
      </section>
    </VipLayout>
  )
}

export default VipFaqPage
